import { CategoryPage } from './CategoryPage';
export default CategoryPage;
export * from './CategoryPage';
